import { USER_ACCOUNTS_QUERY_KEY } from '@/lib/query/constants/account-keys-constants';
import { PIXEL_DESTINATIONS_QUERY_KEY } from '@/lib/query/constants/pixel-destinations-query-key-constants';

const CACHE_DEPENDENCIES: Record<string, string[]> = {
  [USER_ACCOUNTS_QUERY_KEY]: [USER_ACCOUNTS_QUERY_KEY, 'teamMembers'],
  TEAM_MEMBERS: ['teamMembers', USER_ACCOUNTS_QUERY_KEY],
  DESTINATIONS: [PIXEL_DESTINATIONS_QUERY_KEY, 'DESTINATION_CATALOG'],
  PIXEL_CONFIG: [PIXEL_DESTINATIONS_QUERY_KEY, 'pixelConfig'],
  PIXEL_DESTINATIONS: [PIXEL_DESTINATIONS_QUERY_KEY],
  DESTINATION_CATALOG: ['DESTINATION_CATALOG'],
};

export { CACHE_DEPENDENCIES };
